import { Trans } from 'next-i18next'

import { LinkText, Paragraph } from '@/features/Listings/seo/elements'
import useFilterSlug from '@/features/Listings/seo/search-results-content/content/use-filter-slug'

const Amenities = ({ cityName, filterSlug, links }) => {
  const { hasFilter, filterName } = useFilterSlug(filterSlug)

  return (
    <>
      <Paragraph>
        {hasFilter ? (
          <Trans i18nKey="seo:Rental Amenities FILTER in LOCATION Paragraph 1">
            When you’re searching for{' '}
            <LinkText href={`${links.base}/${filterSlug}`}>
              {{ filterName }} in {{ cityName }}
            </LinkText>
            , make sure to look at what amenities are offered. For instance,
            check to see if the rental includes utilities like air conditioning,
            cable and internet or features such as a dishwasher, parking,
            balcony and fridge.
          </Trans>
        ) : (
          <Trans i18nKey="seo:Rental Amenities LOCATION Paragraph 1">
            When you’re searching for an{' '}
            <LinkText href={links.apartment}>
              apartment to rent in {{ cityName }}
            </LinkText>
            , make sure to look at what amenities are offered. For instance,
            check to see if the rental includes utilities like air conditioning,
            cable and internet or features such as a dishwasher, parking,
            balcony and fridge.
          </Trans>
        )}
      </Paragraph>
      <Paragraph>
        <Trans i18nKey="seo:Rental Amenities LOCATION Paragraph 2">
          Tip: When looking at listings on liv.rent, scroll down to the
          &quot;Amenities&quot; section to see what utilities and features are
          included with the rental.
        </Trans>
      </Paragraph>
    </>
  )
}

export default Amenities
